import React from 'react';
import { Link } from 'react-router-dom';

import { leftNavConstants } from '@trqk/components';
import { locale, getExpirationMessage } from '@trqk/utils';

import { usePaymentPlanStatus } from '../../../hooks';
import { HASHES, PATHS } from '../../../constants';

const { HEIGHTS } = leftNavConstants;

/**
 * Shows the user a message about when their Free Trial expires and includes a link to the
 * Payment Plan section of the Settings page.
 */
export const FreeTrialFooter = (): JSX.Element => {
    const { subscriptionSettings } = usePaymentPlanStatus();

    const subscription_expiration_date =
        subscriptionSettings?.subscription_expiration_date ?? null;

    if (subscription_expiration_date === null) {
        return <></>;
    }

    const expirationMessage = getExpirationMessage({
        expirationDate: new Date(subscription_expiration_date),
        verbPast: locale.enUS.EXPIRATION_DATE.EXPIRED,
        verbPresent: locale.enUS.EXPIRATION_DATE.EXPIRES,
    });

    return (
        <div
            className="flex items-center justify-center text-sm text-white bg-primary-500"
            style={{ height: HEIGHTS.ACCOUNT_DROPDOWN }}
        >
            {`${locale.enUS.FREE_TRIAL_FOOTER.YOUR_FREE_TRIAL} ${expirationMessage}.`}
            <Link
                className="ml-2 text-white underline"
                to={({ search }) => ({
                    hash: HASHES.SETTINGS.PAYMENT_PLAN,
                    pathname: PATHS.SETTINGS,
                    search,
                    state: {
                        fromLink: true,
                    },
                })}
            >
                {locale.enUS.FREE_TRIAL_FOOTER.UPGRADE_NOW}
            </Link>
        </div>
    );
};
